export default "__VITE_ASSET__5229fac0__"